"use client";
import { Button } from "./Button";
import { useEffect, useState } from "react";
import GenericAuth from "~/components/auth/GenericAuth";
import Modal, { ModalFooter } from "./Modal";
import { CustomizableLayout } from "~/types/CustomizableLayout";
import { cn } from "~/utils/fontsConfig";

type LoginModalProps = {
    isOpen: boolean;
    setIsOpen: (show: boolean) => void;
    title?: string;
    description?: string;
    callbackUrl?: string;
    openInMode?: "login" | "signup";
    customization?: CustomizableLayout;
};

const LoginModal = ({
    isOpen,
    setIsOpen,
    title,
    description,
    callbackUrl,
    openInMode,
    customization,
}: LoginModalProps) => {
    const [mode, setMode] = useState<"login" | "signup" | undefined>(
        openInMode,
    );
    useEffect(() => {
        if (openInMode) {
            setMode(openInMode);
        }
    }, [openInMode]);

    return (
        <Modal
            title={title}
            description={description}
            open={isOpen}
            onOpenChange={setIsOpen}
            customization={customization}
            footer={
                <>
                    {!mode && (
                        <ModalFooter>
                            <Button
                                onClick={() => {
                                    setMode("login");
                                }}
                                variant="secondary"
                                className={cn(
                                    "w-full max-w-[200px]",
                                    customization?.buttons?.secondary,
                                )}
                            >
                                Log in
                            </Button>
                            <Button
                                onClick={() => {
                                    setMode("signup");
                                }}
                                className={cn(
                                    "w-full max-w-[200px]",
                                    customization?.buttons?.default,
                                )}
                            >
                                Sign up
                            </Button>
                        </ModalFooter>
                    )}
                </>
            }
        >
            {!!mode && (
                <GenericAuth
                    variant="modal"
                    mode={mode}
                    callbackUrl={callbackUrl || undefined}
                    customization={customization}
                />
            )}
        </Modal>
    );
};

export default LoginModal;
